import { getAugmentedNamespace } from './_commonjsHelpers.js';
import * as index from '../node_modules/date-fns/esm/max/index.js';

var require$$35 = /*@__PURE__*/getAugmentedNamespace(index);

export { require$$35 as default };
